import React, { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import cn from 'classnames';
import { useNavigate } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

import { getFullSession } from '../../../../utils/session';
import ClockIcon from '../../../../assets/icons/common/ClockIcon';
import { LOGIN, LOGIN_SESSION_EXPIRED } from '../../../../routes';
import { useGetCustomerQuery } from '../../../../redux/customersApi';

import styles from './styles.module.scss';

const SessionExpireModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [minLeft, setMinLeft] = useState();
  const wasShownFiveMinuteWarningRef = useRef(false);

  const { data: customer } = useGetCustomerQuery();
  const session = getFullSession();
  const navigate = useNavigate();

  const handleLogin = () => {
    const urlParams = new URLSearchParams({ email: customer?.email || '' });
    navigate(`${LOGIN}?${urlParams.toString()}`);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const INTERVAL_TIME = 30000;
    const intervalCallback = () => {
      const diff = session.expiry - Date.now() / 1000;
      if (diff < 0) {
        navigate(LOGIN_SESSION_EXPIRED);
      }
      const diffInMin = Math.round(diff / 60);
      if (1 < diffInMin && diffInMin <= 5) {
        if (!wasShownFiveMinuteWarningRef.current) {
          setShowModal(true);
          wasShownFiveMinuteWarningRef.current = true;
        }
        setMinLeft(diffInMin);
      } else if (diffInMin <= 1) {
        setShowModal(true);
        setMinLeft(diffInMin);
      }
    };

    const intervalId = setInterval(intervalCallback, INTERVAL_TIME);

    return () => {
      clearInterval(intervalId);
    };
  }, [session?.expiry, navigate]);

  return createPortal(
    <CSSTransition
      in={showModal}
      timeout={300}
      classNames={{
        enterActive: styles.animationEnterActive,
        enter: styles.animationEnter,
        exit: styles.animationExit,
        exitActive: styles.animationExitActive,
      }}
      unmountOnExit
    >
      <div className={styles.modal}>
        <div className={styles.content}>
          <ClockIcon className={styles.icon} />
          <div>
            <p className={cn(styles.title, 'text')}>Session Expires</p>
            <p className={cn(styles.text, 'text-s')}>
              Your session is about to expire in {minLeft} minutes and you will
              be logged out. Please make sure to log back in to continue using
              the dashboard
            </p>
          </div>
        </div>
        <div className={styles.buttons}>
          <button
            className={cn('text-s', styles.button, styles.cancel)}
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            className={cn('text-s', styles.button, styles.login)}
            onClick={handleLogin}
          >
            Login
          </button>
        </div>
      </div>
    </CSSTransition>,
    document.getElementById('session-modal-container'),
  );
};

export default SessionExpireModal;
